import { Model } from 'modules/core/lib/mobx-rest'
import type { Analytic } from 'modules/core/store/models/Analytic'

export interface Attributes {
  id: string
  average_age: Analytic<number>
  tenure: Analytic<string>
  diversity: Analytic<number>
}

class JobRoleAnalytics extends Model<Attributes> {
  static urlRoot() {
    return '/analytics/job_roles'
  }
}

export default JobRoleAnalytics
